import axiosResiInstance from "../http/axiosResi";

export const sendAgentView = (agentIds, type = "LISTING_SEARCH") => {
    if (!Array.isArray(agentIds)) {
        agentIds = [agentIds];
    }

    return axiosResiInstance.post("/agent-view-log", {
        agents: agentIds.join(","),
        type,
    });
};

export const getAgentFreeViews = (agentId) => {
    return axiosResiInstance.get(`/agent-view-free/${agentId}`);
};

export const getAgentViews = (agentId, periods = null) => {
    return axiosResiInstance.get(`/agent-view/${agentId}`, {
        params: {
            periods,
        },
    });
};

export const getListingRequests = (agentId, listings) => {
    const listingIds = getListingIds(listings);

    return axiosResiInstance.get(`/agent-listing-request/${agentId}`, {
        params: {
            listings: listingIds.join(),
        },
    });
};

export const getListingViews = (agentId, listings, periods = null) => {
    const listingIds = getListingIds(listings);

    return axiosResiInstance.get(`/agent-listing-view/${agentId}`, {
        params: {
            listings: listingIds.join(),
            periods,
        },
    });
};

const getListingIds = (listings) => {
    if (!listings || listings.length === 0) {
        return [];
    }

    if (typeof listings[0] === "string") {
        return listings;
    }

    let listingIds = [];

    listings.forEach((listing) => {
        listingIds.push(listing.id);
    });

    return listingIds;
};
